<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>经销商列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input placeholder="请输入经销商名称" v-model="queryInfo.query" clearable @clear="getUserList">
            <el-button slot="append" icon="el-icon-search" @click="getUserList"></el-button>
          </el-input>
        </el-col>
        <!-- -->
        <el-col :span="6" v-if="canLook == 1">
          <el-button type="primary" size="mini" @click="openAddDialog">添加经销商</el-button>
          <el-button type="primary" size="mini" @click="mutableSetSalesman">批量修改业务员</el-button>
        </el-col>
        <el-col :span="2" v-if="canLook == 1">
          <a class="aaaa" :href="exportUrl">
            <el-button size="mini" type="info">导出表格</el-button>
          </a>
        </el-col>
		<el-col :span="2" v-if="canLook == 1">
		  <a class="aaaa" target="_blank" :href="'https://hsznttghpt.hsxsn.cn/exportUserGood?user_id='+0">
		    <el-button size="mini" type="info">一键导出商品</el-button>
		  </a>
		</el-col>
      </el-row>

      <!-- 用户列表区域 -->
      <el-table :data="userlist" border stripe @selection-change="handleSelectionChange">
        <el-table-column fixed type="selection" width="55"> </el-table-column>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="名称" prop="agencyName"></el-table-column>

        <el-table-column label="联系人" prop="username"></el-table-column>
        <el-table-column label="联系电话" prop="contactPhone" width="100px"></el-table-column>
        <el-table-column label="登陆手机号" prop="phone" width="100px"></el-table-column>
        <el-table-column label="地址" prop="agencyAddress" width="150px"></el-table-column>
        <!-- <el-table-column label="区域" prop="buTypeTxt"></el-table-column> -->
        <el-table-column label="业务员" prop="salemanTxt"></el-table-column>
        <el-table-column label="百分比" prop="percentage"></el-table-column>
        <el-table-column label="经销渠道" prop="jxtypetext"></el-table-column>
        <!-- <el-table-column label="授信余额" prop="creditMoney"></el-table-column> -->
        <el-table-column label="状态" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" @change="userStateChanged(scope.row)"> </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160px" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.phone)"></el-button>
			<a class="aaaa" target="_blank" :href="'https://hsznttghpt.hsxsn.cn/exportUserGood?user_id='+scope.row.id">
			  <el-button size="mini" type="info">导出商品</el-button>
			</a>
            <!-- <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeUserById(scope.row.phone)"></el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 添加用户的对话框 -->
    <el-dialog title="添加经销商" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="130px">
		<el-form-item label="订单归属公司" prop="company">
		  <el-radio v-model="addForm.company" :label="1" >皇氏智能</el-radio>
		  <el-radio v-model="addForm.company" :label="2">供应链</el-radio>
		  <el-radio v-model="addForm.company" :label="3">皇氏威铭</el-radio>
		</el-form-item>
        <el-form-item label="名称" prop="agencyName">
          <el-input v-model="addForm.agencyName"></el-input>
        </el-form-item>
        <el-form-item label="登陆手机号" prop="phone">
          <el-input v-model="addForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="登陆密码" prop="password">
          <el-input v-model="addForm.password"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="username">
          <el-input v-model="addForm.username"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input v-model="addForm.contactPhone"></el-input>
        </el-form-item>
        <el-form-item label="发票抬头" prop="fapiaoHeader">
          <el-input v-model="addForm.fapiaoHeader"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="agencyAddress">
          <el-input v-model="addForm.agencyAddress" placeholder="请输入经销商详细地址"></el-input>
        </el-form-item>
        <el-form-item label="经销渠道" prop="saleman1">
          <el-checkbox-group v-model="jxtype1" @change="changeSaleman">
            <el-checkbox v-for="item in jxstypelist" :label="item.id" :key="item.id" >{{ item.name }}</el-checkbox>
          </el-checkbox-group>
          <!-- <el-select v-model="addForm.jxtype" filterable placeholder="请选择">
            <el-option v-for="item in jxstypelist" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="价格百分比(%)" prop="percentage">
          <el-input v-model="addForm.percentage" type="number" placeholder="请输入经销数字"></el-input>
        </el-form-item>
        <el-form-item label="所属业务员" prop="saleman">
          <el-select v-model="addForm.saleman" filterable placeholder="请选择">
            <el-option v-for="item in salemans" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUser">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改用户的对话框 -->
    <el-dialog title="修改用户" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
      <el-form :model="editForm" :rules="addFormRules" ref="editFormRef" label-width="130px">
		<el-form-item label="订单归属公司" prop="company">
		  <el-radio v-model="editForm.company" :label="1" >皇氏智能</el-radio>
		  <el-radio v-model="editForm.company" :label="2">供应链</el-radio>
		  <el-radio v-model="editForm.company" :label="3">皇氏威铭</el-radio>
		</el-form-item>
        <el-form-item label="登陆手机号">
          <el-input v-model="editForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="经销商名称" prop="agencyName">
          <el-input v-model="editForm.agencyName"></el-input>
        </el-form-item>
        <el-form-item label="登陆密码" prop="password">
          <el-input v-model="editForm.password"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="username">
          <el-input v-model="editForm.username"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input v-model="editForm.contactPhone"></el-input>
        </el-form-item>
        <el-form-item label="发票抬头" prop="fapiaoHeader">
          <el-input v-model="editForm.fapiaoHeader"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="agencyAddress">
          <el-input v-model="editForm.agencyAddress" placeholder="请输入经销商详细地址"></el-input>
        </el-form-item>
        <el-form-item label="经销渠道" prop="saleman1">
          <el-checkbox-group v-model="jxtype1" @change="changeSaleman">
            <el-checkbox v-for="item in jxstypelist" :label="item.id" :key="item.id" >{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="价格百分比(%)" prop="percentage">
          <el-input v-model="editForm.percentage" type="number" placeholder="请输入经销数字"></el-input>
        </el-form-item>
        <el-form-item label="所属业务员" prop="saleman">
          <el-select v-model="editForm.saleman" filterable placeholder="请选择">
            <el-option v-for="item in salemans" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUserInfo">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="批量修改业务员" :visible.sync="changeSalemanialogVisible" width="50%" @close="changeSalemanDialogClosed">
      <el-form :model="changeSalemanForm" :rules="changeSalemanRules" ref="changeSalemanFormRef" label-width="130px">
        <el-form-item label="选择业务员" prop="saleman">
          <el-select v-model="changeSalemanForm.saleman" filterable placeholder="请选择">
            <el-option v-for="item in salemans" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeSalemanialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeSalemansure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    // 验证邮箱的规则
    var checkEmail = (rule, value, cb) => {
      // 验证邮箱的正则表达式
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/

      if (regEmail.test(value)) {
        // 合法的邮箱
        return cb()
      }

      cb(new Error('请输入合法的邮箱'))
    }

    // 验证手机号的规则
    // var checkMobile = (rule, value, cb) => {
    //   // 验证手机号的正则表达式
    //   const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57]|19[0-9])[0-9]{8}$/
    //   if (regMobile.test(value)) {
    //     return cb()
    //   }
    //   cb(new Error('请输入合法的手机号'))
    // }

    return {
      canLook: 1,
	  radio:'1',
      exportUrl: 'https://hsznttghpt.hsxsn.cn/exportUserList?mPhone=' + localStorage.getItem('phone'),
      // 获取用户列表的参数对象
      queryInfo: {
        query: '',
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 10
      },

      userlist: [],
      jxstypelist:[
        {id:1, name: '团购'},
        {id:2,name: '校园'},
        // {id:3,name:'全渠道'},
        {id: 4, name: '特渠'}

      ],
      salemans: [],//所有的业务员


      total: 0,
      // 控制添加用户对话框的显示与隐藏
      addDialogVisible: false,
      // 添加用户的表单数据
      addForm: {
        agencyName: '',
        phone: '',
        password: '',
        username: '',
        contactPhone: '',
        fapiaoHeader: '',
        buType: true,
        jxtype: [],
        percentage: '',
        agencyAddress: null,
        saleman: null,
        creditMoney: 0,
		company: 1,
        jxtypetext: []

      },
      // 添加表单的验证规则对象
      addFormRules: {
        agencyName: [
          { required: true, message: '请输入经销商名称', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          // { validator: checkMobile, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            min: 6,
            max: 15,
            message: '用户名的长度在6~15个字符之间',
            trigger: 'blur'
          }
        ], username: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' },

        ],
        contactPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          // { validator: checkMobile, trigger: 'blur' }
        ],
        fapiaoHeader: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' },
        ],
        agencyAddress: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
        ],
        saleman: [
          { required: true, message: '请选择业务员', trigger: 'blur' },
        ],
        saleman1: [
          // { required: true, message: '请选择经销渠道', trigger: 'blur' },
        ],
        creditMoney: [
          { required: true, message: '请输入授信余额', trigger: 'blur' },

        ]
      },



      // 控制修改用户对话框的显示与隐藏
      editDialogVisible: false,

      // 查询到的用户信息对象
      editForm: {
        id: '',
        agencyName: '',
        phone: '',
        password: '',
        username: '',
        contactPhone: '',
        fapiaoHeader: '',
        percentage: '',
        jxtype: [],
        buType: true,
        agencyAddress: null,
        saleman: null,
        creditMoney: 0,
		company: 1
      },
      jxtype:[],
      jxtype1:[],
      // 修改表单的验证规则对象
      editFormRules: {
        agencyName: [
          { required: true, message: '请输入经销商名称', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          // { validator: checkMobile, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            min: 6,
            max: 15,
            message: '用户名的长度在6~15个字符之间',
            trigger: 'blur'
          }
        ], username: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' },
        ],
        contactPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          // { validator: checkMobile, trigger: 'blur' }
        ],
        fapiaoHeader: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' },
        ],
        agencyAddress: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
        ],
        saleman1: [
          // { required: true, message: '请选择经销渠道', trigger: 'blur' },
        ],
        saleman: [
          { required: true, message: '请选择业务员', trigger: 'blur' },
        ],
        creditMoney: [
          { required: true, message: '请输入授信余额', trigger: 'blur' },
        ]
      },
      //批量修改业务员
      changeSalemanialogVisible: false,
      changeSalemanId: 0,

      changeSalemanForm: {
        saleman: null,
      },
      changeSalemanRules: {
        saleman: [
          { required: true, message: '请选择业务员', trigger: 'blur' },
        ],
      },
      multipleSelection: [],
      multipleSelectionjson: null,
    }
  },

  created () {

    this.getUserList()
    this.getUserRoleList()
    this.getSalemansList()
  },

  methods: {
    // 经销渠道多选
    changeSaleman(val) {
      this.editForm.jxtype = val;
      this.addForm.jxtype = val;
      console.log("经销渠道id集合:",JSON.stringify(val))
    },

    // 多选选择的项
    handleSelectionChange (val) {
      this.multipleSelection = [];
      val.forEach(element => {
        this.multipleSelection.push({ 'id': element.id });
      });
      if (this.multipleSelection) {

        this.multipleSelectionjson = JSON.stringify(this.multipleSelection);
        this.exportUrl = 'https://hsznttghpt.hsxsn.cn/exportUserList?data=' + this.multipleSelectionjson + '&mPhone=' + localStorage.getItem('phone')
          + '&mPhone=' + localStorage.getItem('phone')
      } else {
        this.multipleSelectionjson = null;
        // this.exportUrl = "javascript:return false;"
        this.exportUrl = 'https://hsznttghpt.hsxsn.cn/exportUserList?mPhone=' + localStorage.getItem('phone')
      }
    },

    //批量修改业务员
    async mutableSetSalesman () {
      if (this.multipleSelection.length == 0) {
        return this.$message.error('请先勾选经销商')
      }
      this.changeSalemanialogVisible = true
    },



    //批量修改业务员
    async changeSalemansure () {
      const { data: res } = await this.$http.post('admin/user/mutableSetSalesman', {
        data: this.multipleSelection,
        salemanid: this.changeSalemanForm.saleman
      })
      this.multipleSelection = [];
      if (res.code !== 200) {
        return this.$message.error('设置失败！')
      }
      this.$message.success('设置成功！')
      this.getUserList();
      this.changeSalemanialogVisible = false;
    },


    async getUserList () {

      const { data: res } = await this.$http.get('admin/users/getAllUsers', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('暂无用户列表！')
      }
      this.userlist = res.result.list
      this.total = res.result.count
      // console.log(window.sessionStorage.getItem('pathCanLook'));
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
      console.log(this.canLook);
      console.log('啦啦啦',res)
    },

    async getUserRoleList () {
      const { data: res } = await this.$http.get('admin/user/getUserType')
      if (res.code !== 200) {
        return this.$message.error('暂无角色列表！')
      }
      this.rolesList = res.result
      console.log(res)
    },

    // 业务员数据
    async getSalemansList () {
      const { data: res } = await this.$http.get('admin/user/getInUseSalemans')
      if (res.code !== 200) {
        return this.$message.error('暂无业务员！')
      }
      this.salemans = res.result
      console.log(res)
    },


    // 监听 pagesize 改变的事件
    handleSizeChange (newSize) {
      // console.log(newSize)
      this.queryInfo.pagesize = newSize
      this.getUserList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange (newPage) {
      console.log(newPage)
      this.queryInfo.pagenum = newPage
      this.getUserList()
    },

    // 监听 switch 开关状态的改变
    async userStateChanged (userinfo) {
      console.log(userinfo)
      const { data: res } = await this.$http.post('/admin/users/updateUser', {
        status: userinfo.status,
        phone: userinfo.phone
      })
      if (res.code !== 200) {
        userinfo.mg_state = !userinfo.mg_state
        return this.$message.error('更新用户状态失败！')
      }
      this.$message.success('更新用户状态成功！')
    },

    // 监听添加用户对话框的关闭事件
    addDialogClosed () {
      this.$refs['addFormRef'].resetFields()
    },

    changeSalemanDialogClosed () {
      this.$refs.changeSalemanFormRef.resetFields()
    },

    addMoneyDialogVisibleClosed () {
      this.$refs.czFormRef.resetFields()
    },

    openAddDialog() {
      this.addDialogVisible = true;
      this.$nextTick(()=>{
        this.jxtype1.length = 0;
        console.log("打开添加弹窗")
        this.$refs.addFormRef.resetFields()
      })
    },

    // 点击按钮，添加新用户
    addUser () {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return
        console.log("添加用户提交的数据:",this.addForm)
        // 可以发起添加用户的网络请求
        const { data: res } = await this.$http.post('admin/users/addUser', this.addForm)
        if (res.code !== 200) {
          this.$message.error(res.message)
          return;
        }
        this.$message.success(res.message)
        // 隐藏添加用户的对话框
        this.addDialogVisible = false
        // 重新获取用户列表数据
        this.getUserList()
      })
    },

    // 展示编辑用户的对话框
    async showEditDialog (phone) {
      // console.log("传电话：？？",phone)
      const { data: res } = await this.$http.get('admin/users/base', {
        params: { phone: phone }
      })
      // console.log("展示编辑用户信息:",res)
      this.jxtype1 = res.result.jxtype
      if (res.code !== 200) {
        return this.$message.error('查询用户信息失败！')
      }
      this.editForm = res.result
      this.jxtype.length = 0;
      this.jxtype.push(res.result.jxtype)
      this.editDialogVisible = true
    },

    // 监听修改用户对话框的关闭事件
    editDialogClosed () {
      this.$refs.editFormRef.resetFields()
    },
    // 修改用户信息并提交
    editUserInfo () {
      console.log("修改用户提交的数据:", this.editForm)
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return
        // 发起修改用户信息的数据请求
        const { data: res } = await this.$http.post(
          'admin/users/info',
          this.editForm
        )
        if (res.code !== 200) {
          return this.$message.error('更新用户信息失败！')
        }

        // 关闭对话框
        this.editDialogVisible = false
        // 刷新数据列表
        this.getUserList()
        // 提示修改成功
        this.$message.success('更新用户信息成功！')
      })
    },
    // 根据Id删除对应的用户信息
    async removeUserById (phone) {
      // 弹框询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将永久删除该用户, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      const { data: res } = await this.$http.post('admin/users/delete', { phone: phone })
      if (res.code !== 200) {
        return this.$message.error('删除用户失败！')
      }
      this.$message.success('删除用户成功！')
      this.getUserList()
    },
  }
}
</script>

<style lang="less" scoped>
.aaaa {
  margin-left: 10px;
}
</style>
